import { SVGProps, Ref, forwardRef } from 'react';

export const HrBrandOutlinedCircledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M8.185 3.203A2.93 2.93 0 0 0 9.372 6.12c.962.688 2.2.731 3.181.211z" fill="currentColor" />
                <path d="M12.667 6.677c-1.104.148-2.08.9-2.448 2.014A2.92 2.92 0 0 0 11 11.74z" fill="currentColor" />
                <path d="M5.3 11.953A3 3 0 0 1 8 10.281a3 3 0 0 1 2.7 1.672z" fill="currentColor" />
                <path
                    d="M5.78 8.692a2.92 2.92 0 0 1-.778 3.047L3.333 6.677c1.104.148 2.08.9 2.448 2.015"
                    fill="currentColor"
                />
                <path
                    d="M6.628 6.12c-.962.689-2.2.731-3.18.211l4.367-3.128A2.93 2.93 0 0 1 6.628 6.12"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 .667C2.5.667.667 4.333.667 8S2.5 15.333 8 15.333 15.333 11.667 15.333 8 13.5.667 8 .667m-4.807 3.06C2.283 4.818 1.867 6.345 1.867 8s.416 3.182 1.326 4.273c.878 1.054 2.346 1.86 4.807 1.86s3.93-.806 4.807-1.86c.91-1.091 1.326-2.618 1.326-4.273s-.416-3.182-1.326-4.273C11.93 2.673 10.461 1.867 8 1.867s-3.93.806-4.807 1.86"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
HrBrandOutlinedCircledSize16Glyph.displayName = 'HrBrandOutlinedCircledSize16Glyph';
